document.addEventListener("turbo:load", () => {
	$(document).off('click', 'a.add-row');
	$(document).on('click', 'a.add-row', function(ev) {
		ev.preventDefault();
		ev.stopPropagation();
		let $el = ev.currentTarget;
		let	$at = document.querySelector($el.dataset.at);
		$at.insertAdjacentHTML('beforeend', $el.dataset.fields.replace(/change\-me/ig, new Date().getTime()));
    ev.currentTarget.dispatchEvent(new CustomEvent("add-row:appended", { detail: { row: $at.lastChild }}));
	});
});